import { AimOutlined, SmileOutlined, FireOutlined } from "@ant-design/icons";

export const flunkyInstructionIcons = [
    <AimOutlined key="first" style={{ color: "#389e0d" }} />,
    <SmileOutlined key="second" style={{ color: "#faad14" }} />,
    <FireOutlined key="third" style={{ color: "#fa541c" }} />,
];
